import React from "react";
import { urlFor } from "../client";
import Loading from "./Loading/Loading";

const RecentBlog = ({ recentBlog }) => {
  return (
    <>
      {recentBlog ? (
        <div id="singleBlog">
          <div className="publish">
            <small>
              By <span>Laser Treat</span> at <span>{recentBlog.location}</span>{" "}
              on <span>{recentBlog.dop}</span>
            </small>
          </div>
          <img src={urlFor(recentBlog.blogimg)} alt="" className="bigBanner" />

          <div className="title">
            <h1>{recentBlog.title}</h1>
          </div>

          <p className="det">{recentBlog.fulldesc}</p>

          <div className="realted-photos">
            <h2>Related Photos</h2>
            <div className="gallery">
              <img src={urlFor(recentBlog.otherimg1)} alt="" className="gal" />
              <img src={urlFor(recentBlog.otherimg2)} alt="" className="gal" />
              <img src={urlFor(recentBlog.otherimg3)} alt="" className="gal" />
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default RecentBlog;
